import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/HomePage.scss';
import musicalNote1 from '../assets/icons/musical_note1.png';
import musicalNote2 from '../assets/icons/musical_note2.png';
import phoneIcon from '../assets/icons/phone.png';
import petsIcon from '../assets/icons/pets.png';

const HomePage = () => {
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [timeLeft, setTimeLeft] = useState({});
  const [scrollY, setScrollY] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [showContactButton, setShowContactButton] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const weddingDate = new Date('2026-03-28T09:00:00');
  const audioRef = React.useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollY(currentScrollY);
      setShowContactButton(currentScrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    audioRef.current = new Audio('/BrunoMars_MarryYou.mp3');
    audioRef.current.loop = true;
    audioRef.current.volume = 0.3;
    
    // เล่นเพลงอัตโนมัติเมื่อโหลดหน้า
    const playAudio = async () => {
      try {
        await audioRef.current.play();
        setIsPlaying(true);
      } catch (e) {
        console.log('Auto-play failed:', e);
        // ถ้า auto-play ไม่ได้ ให้รอ user interaction
      }
    };
    
    playAudio();
    
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
      }
    };
  }, []);

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const difference = weddingDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, []);

  const toggleMusic = async () => {
    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      try {
        await audioRef.current.play();
        setIsPlaying(true);
      } catch (e) {
        console.log('Audio play failed:', e);
        setIsPlaying(false);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (name.trim() && message.trim()) {
      setIsSubmitting(true);
      try {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
        await axios.post(`${apiUrl}/api/wishes`, {
          guestName: name.trim(),
          message: message.trim()
        });
        navigate('/thank-you');
      } catch (error) {
        console.error('Error sending wish:', error);
        alert('เกิดข้อผิดพลาดในการส่งคำอวยพร กรุณาลองใหม่อีกครั้ง');
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <div className="home-page">
      {/* Fixed Buttons */}
      <div className="fixed-buttons">
        <button className={`contact-toggle ${showContactButton ? 'show' : ''}`} onClick={() => setShowContact(true)}>
          <img src={phoneIcon} alt="Contact" />
        </button>
        <button className={`music-toggle ${isPlaying ? 'playing' : ''}`} onClick={toggleMusic}>
          <img 
            src={isPlaying ? musicalNote2 : musicalNote1} 
            alt="Music Toggle" 
          />
        </button>
      </div>

      {/* Contact Popup */}
      {showContact && (
        <div className="contact-overlay" onClick={() => setShowContact(false)}>
          <div className="contact-popup" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowContact(false)}>×</button>
            <h3>ติดต่อเจ้าบ่าวเจ้าสาว</h3>
            <div className="contact-info">
              <div className="contact-item">
                <strong>เจ้าสาว (อัน)</strong>
                <p>โทร: <a href="tel:090-901-xxxx">090-901-xxxx</a></p>
              </div>
              <div className="contact-item">
                <strong>เจ้าบ่าว (เก๋าลัค)</strong>
                <p>โทร: <a href="tel:090-889-xxxx">090-889-xxxx</a></p>
              </div>
            </div>
          </div>
        </div>
      )}

      <section className="hero-banner" style={{
        opacity: Math.max(0, 1 - scrollY / 800),
        transform: `translateY(${scrollY * 0.2}px)`
      }}>
        <div className="banner-content">
          <div className="invitation-text">
            <div className="couple-names">AUN & KAOLUCK</div>
            <p className="wedding-text">WEDDING DAY</p>
          </div>
          <div className="scroll-indicator">
            <div className="scroll-arrow"></div>
            <p>เลื่อนลงเพื่อดูรายละเอียด</p>
          </div>
        </div>
      </section>

      <section className="couple-section">
        <div className="container">
          <div className="couple-info">
            <p className="wedding-date">วันเสาร์ที่ 28 มีนาคม 2569</p>
            <p className="wedding-date en">On Saturday , 28 March 2026</p>
            <p className="wedding-time">เวลา 09.00 - 12.00 น.</p>
          </div>
        </div>
      </section>

      <section className="countdown-section">
        <div className="container">
          <div className="countdown-header">
            <h2>Countdown</h2>
            <p className="countdown-subtitle">Until Our Special Day</p>
          </div>
          <div className="countdown">
            {['days', 'hours', 'minutes', 'seconds'].map((unit) => (
              <div key={unit} className="time-unit">
                <div className="vintage-frame">
                  <span className="number">{timeLeft[unit] || 0}</span>
                </div>
                <span className="label">{unit.charAt(0).toUpperCase() + unit.slice(1)}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="location-section">
        <div className="container">
          <h2>Location</h2>
          <div className="location-info">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d763.1900041173437!2d103.01023581321358!3d15.417778873458557!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sth!2sth!4v1768013129023!5m2!1sth!2sth"
              width="100%" 
              height="400" 
              style={{border: 0, borderRadius: '15px'}} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Wedding Location"
            />
            <p>
              <a href="https://maps.app.goo.gl/1eDi55mM7VQKRAps7" target="_blank" rel="noopener noreferrer">
                คลิกเพื่อดูแผนที่ใน Google Maps
              </a>
            </p>
          </div>
          <div className="location-contact">
            <h3>Contact Information</h3>
            <div className="contact-grid">
              <div className="contact-card">
                <div className="contact-name">Bride (Aun)</div>
                <a href="tel:090-901-xxxx" className="contact-phone">090-901-xxxx</a>
              </div>
              <div className="contact-card">
                <div className="contact-name">Groom (Kaoluck)</div>
                <a href="tel:090-889-xxxx" className="contact-phone">090-889-xxxx</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="schedule-section">
        <div className="container">
          <h2>กำหนดการ</h2>
          <div className="schedule-list">
            {[
              { time: '09.00 น.', event: 'พิธีแห่ขันหมาก' },
              { time: '09.30 น.', event: 'พิธีสู่ขวัญ' },
              { time: '10.10 น.', event: 'พิธีรับไหว้หรือผูกข้อมือ' },
              { time: '11.00 น. เป็นต้นไป', event: 'ร่วมรับประทานอาหาร' }
            ].map((item, index) => (
              <div key={index} className="schedule-item">
                <span className="time">{item.time}</span>
                <span className="event">{item.event}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="wish-form-section">
        <div className="container">
          <h2>ส่งคำอวยพร</h2>
          <form onSubmit={handleSubmit} className="wish-form">
            <div className="form-group">
              <input
                type="text"
                placeholder="ชื่อของคุณ *"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <textarea
                placeholder="คำอวยพร *"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows="4"
                required
              />
            </div>
            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <span className="loading-spinner"></span>
                  กำลังส่ง...
                </>
              ) : (
                'ส่งคำอวยพร'
              )}
            </button>
          </form>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <p>A & K</p>
          <p className='quote'>I have found the one whom my soul loves.</p>
          <div className="pets-icons">
            <img src={petsIcon} alt="Pet 1" />
            <img src={petsIcon} alt="Pet 2" />
            <img src={petsIcon} alt="Pet 3" />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;